module.exports = __webpack_public_path__ + "img/attention_icon.1245864c.svg";